module.exports = __webpack_public_path__ + "static/screenshot2-f62f605766b113492e8acb94924bcb92.png";